module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spacer"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("An error has occured! (" + _vm._s(_vm.code) + ")")]), _vm._v(" "), _c('h4', {
    staticClass: "my-3"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('button', {
    staticClass: "btn green wide m-5",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.backHome.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        « Back to Pluralo\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4c8ca65a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c8ca65a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/Error.vue
// module id = 3025
// module chunks = 0